import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { Colors } from "./components/colors";
import Footer from "./components/footer.jsx";
import NavBar from "./components/navbar.jsx";
import Button from "./components/button.jsx";
import TextInput from "./components/textBox";
import Link from "./components/link.jsx";
import Alert from "@mui/material/Alert";
import { withTranslation } from 'react-i18next';

class Login extends React.Component {
  
  constructor(props) {
    // Initialize mutable state
    super(props);
    this.state = {
      email: "",
      password: "",
      failed: false,
      activebutton: Colors.lightGray,
      disableButton: true
    };
  }
  
  //check if fields are empty to lightup the submit button
  checkEmpty() {
    if (this.state.email && this.state.password) {
      this.setState({ activebutton: Colors.buttonColor, disableButton: false });
      return false;
    } else {
      this.setState({ activebutton: Colors.lightGray, disableButton: true });
      return true;
    }
  }
  componentDidMount() {
    // Check if the URL has a message parameter
    const urlParams = new URLSearchParams(window.location.search);
    const messageParam = urlParams.get("message");
    this.setState({ message: messageParam || "" });
  }

  handleEmailChange = (value) => {
    // Do something with the input value
    this.setState({ email: value }, this.checkEmpty);
  };

  handlePasswordChange = (value) => {
    // Do something with the input value
    this.setState({ password: value }, this.checkEmpty);
  };

  submitOnEnter = (e) => {
    if (e.key === "Enter" && !this.checkEmpty()) {
      this.loginOnClick();
    }
  };

  // Logs in account when button is clicked
  loginOnClick() {
    // Build the form
    const formData = new FormData();
    formData.append("email", this.state.email);
    formData.append("password", this.state.password);
    formData.append("operation", "login");
    // Submit the form
    fetch(`/accounts/`, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formData).toString(),
    }).then((response) => {
      if (response.ok) {
        // Redirect logic here
        window.location.href = "/"; // Redirect to the home page
      } else {
        // Handle login failure, show error message, etc.
        this.setState({ failed: true }, this.checkEmpty);
      }
    });
  }

  render() {
    // This line automatically assigns this.state.imgUrl to the const variable imgUrl
    // and this.state.owner to the const variable owner
    const { email, password, failed, activebutton, disableButton, message } =
      this.state;

    // Render index

    return (
      <MainCol  dir={this.props.i18n.dir()}>
        <NavBar />
        <Page>
          <h1>{this.props.t("login_signin")}</h1>
          {failed ? (
            <Alert severity="error">
              {this.props.t("login_alert_no_account")}
            </Alert>
          ) : (
            message && (
              <Alert severity="info">
                You have to login first before adding salaries
              </Alert>
            )
          )}
          <TextInput
            value={email}
            placeholder={this.props.t("login_email")}
            func={this.handleEmailChange}
            isfailed={failed}
            onKeyDown={this.submitOnEnter}
          />
          <TextInput
            type="password"
            value={password}
            placeholder={this.props.t("login_password")}
            func={this.handlePasswordChange}
            isfailed={failed}
            onKeyDown={this.submitOnEnter}
          />
          <Linkforgor>
            <Link
              linkText={this.props.t("login_forgot_password")}
              color={Colors.black}
              href="/404"
            />
          </Linkforgor>
          <Button
            disable={disableButton}
            title={this.props.t("login_login")}
            func={() => this.loginOnClick()}
            color={activebutton}
            textColor={Colors.white}
          />
          <Linkup>
            <Link
              linkText={this.props.t("login_not_a_member")}
              color={Colors.black}
              href="/signup"
            />
          </Linkup>
        </Page>
        <Footer />
      </MainCol>
    );
  }
}
export default withTranslation()(Login);

// Create a flex column display div
const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MainCol = styled(FlexCol)`
  justify-content: space-between;
  height: 100vh;
  margin-top: 50px;
`;

// Create a flex column display div
const Page = styled(FlexCol)`
  align-items: center;
  justify-items: space-around;
  text-align: center;
  width: 20%;
    min-width:300px;
`;

const Linkforgor = styled.div`
  text-align: end;
  width: 100%;
  font-size: 14px;
`;

const Linkup = styled(Linkforgor)`
  text-align: center;
  padding-bottom: 8px;
`;
